import { useCallback } from 'react';

import { BuilderModal } from 'src/features/builder-modal/BuilderModal';
import { useAppDispatch } from 'src/hooks/useStore';
import { ResetESignToInitialValues } from 'src/store/signaturePage/actions';

import {
  ContractBuilderModalContent,
  CreatedContractData,
} from './ContractBuilderModalContent';

export type { CreatedContractData } from './ContractBuilderModalContent';

interface ContractBuilderModalProps {
  isOpen: boolean;
  onClose: (createdContract?: CreatedContractData) => void;
  initialTitle?: string;
  defaultOneOff?: boolean;
  initialRecipient?: { clientId: string; companyId: string } | null;
}

export const ContractBuilderModal = ({
  isOpen,
  onClose,
  initialTitle,
  defaultOneOff,
  initialRecipient,
}: ContractBuilderModalProps) => {
  const dispatch = useAppDispatch();
  const resetESign = useCallback(
    () => dispatch(ResetESignToInitialValues()),
    [dispatch],
  );

  return (
    <BuilderModal isOpen={isOpen} onClose={onClose} onReset={resetESign}>
      {(handleClose) => (
        <ContractBuilderModalContent
          onClose={handleClose}
          initialTitle={initialTitle}
          defaultOneOff={defaultOneOff}
          initialRecipient={initialRecipient}
        />
      )}
    </BuilderModal>
  );
};
